var map = {
	"./avatars.coffee": 1808,
	"./block-options.coffee": 1809,
	"./bubble-guide.js": 1810,
	"./calendar-events.coffee": 1811,
	"./cc-members.js": 1812,
	"./charts/chart.coffee": 547,
	"./check-items.js": 1813,
	"./comments.js": 1814,
	"./d18n.coffee": 1815,
	"./date-range-filter.coffee": 1816,
	"./dialogs.coffee": 1817,
	"./doc-dir.js": 1818,
	"./docs.coffee": 1819,
	"./favicon.coffee": 1820,
	"./files.js": 1821,
	"./focus-drivers.coffee": 1822,
	"./gallery.coffee": 529,
	"./group-select.js": 1823,
	"./header.coffee": 1824,
	"./index.js": 1656,
	"./inline_video.coffee": 528,
	"./invite.js": 1825,
	"./like.coffee": 1826,
	"./manage-members.coffee": 1827,
	"./manage-projects.coffee": 1828,
	"./mobile-verification.coffee": 548,
	"./notifications-box.coffee": 1829,
	"./password-confirm-dialog.coffee": 1830,
	"./project-badge.coffee": 1831,
	"./project-groups.coffee": 1832,
	"./project-templates.coffee": 1833,
	"./projects-autoload.coffee": 1834,
	"./publication.coffee": 1835,
	"./pusher.js": 1836,
	"./resources.coffee": 1837,
	"./search-bar.coffee": 1838,
	"./selectors.coffee": 1839,
	"./shared/block-options.coffee": 349,
	"./streams.coffee": 1840,
	"./suggest.coffee": 1841,
	"./system-message.coffee": 1842,
	"./teams.coffee": 1843,
	"./todolists.js": 1844,
	"./todos.js": 1845,
	"./topics.coffee": 1846,
	"./tower-pro.coffee": 1847,
	"./work-status.coffee": 1848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1807;